import { observer } from 'mobx-react';
import * as React from 'react';
import { DragHandleProps } from '../../../../../../../Draggable/Types';
import DragIndicatorIcon from '../../../../../../Cutesies/DragIndicatorIcon';
import { ExperienceResource } from '../../../../../Types';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../../Types';
import ExperienceRowItems from './ExperienceRowItems';
import { ShowUnlicensedToggle } from '../../ExperienceCatalog/Types';

interface Props {
  context: ModifiableExperiencesContext;
  store: LearningCollectionEditStore;
  experienceResource: ExperienceResource;
  dragHandleProps: DragHandleProps;
  showLockIcon: ShowUnlicensedToggle;
}

const ExperienceRowItemsWithHandlers: React.FC<Props> = ({
  context,
  store,
  experienceResource,
  dragHandleProps,
  showLockIcon,
}) => {
  return (
    <>
      <td className="text-center">
        <input
          className="h-5 w-4 cursor-pointer text-teal-600"
          type="checkbox"
          name="modifyExperience"
          checked={true}
          onChange={() => store.removeExperienceStore(context, experienceResource)}
          aria-label="Remove experience from collection"
        />
      </td>
      <td className="text-center">
        <div
          className="inline-block cursor-grab"
          {...dragHandleProps}
          aria-label="Drag to reorder experience"
        >
          <DragIndicatorIcon />
        </div>
      </td>
      <ExperienceRowItems
        context={context}
        experienceResource={experienceResource}
        store={store}
        showLockIcon={showLockIcon}
      />
    </>
  );
};

export default observer(ExperienceRowItemsWithHandlers);
